require([
    "common/accordion"
],
function (accordion) {

    function initEventHandlers() {
        $(window).off("resize.dynamicMobileAccordion").on("resize.dynamicMobileAccordion", windowResized);
        accordion.init(".dynamic-mobile-accordion");
    }

    var views = {
        desktop: 1,
        mobile: 2
    };

    var currentView = views.desktop;
    var mobileBreakpoint;

    function windowResized(event) {
        var width = $(window).width();
        if (!mobileBreakpoint) {
            mobileBreakpoint = $(".dynamic-mobile-accordion").data("mobileBreakpoint");
        }

        if (width < mobileBreakpoint && currentView === views.desktop) {
            // SWITCH FROM DESKTOP TO MOBILE
            moveTitleText(".desktop-accordion-title-X", ".mobile-accordion-item-X > .custom-accordion-title");
            moveContent(".desktop-accordion-content-X", ".mobile-accordion-item-X > .custom-accordion-content",
                        ".desktop-accordion-item-X", ".dynamic-mobile-accordion");
            currentView = views.mobile;
        } else if (width >= mobileBreakpoint && currentView === views.mobile) {
            // SWITCH FROM MOBILE TO DESKTOP
            moveTitleText(".mobile-accordion-item-X > .custom-accordion-title", ".desktop-accordion-title-X");
            moveContent(".mobile-accordion-item-X > .custom-accordion-content", ".desktop-accordion-content-X",
                        ".dynamic-mobile-accordion", ".desktop-accordion-item-X");
            currentView = views.desktop;
        }
    }

    function moveTitleText(sourceSelector, targetSelector) {
        $(".dynamic-mobile-accordion div[class*=mobile-accordion-item-]").each(function (i, element) {
            var x = $(element).data("itemNumber");
            var source = sourceSelector.replace("X", x);
            var target = targetSelector.replace("X", x);

            $(target).html($(source).html());   // this copies the DOM elements
            $(source).empty();

            // display the accordion element if it has a title, hide it otherwise
            if ($(target).html()) $(element).removeClass("d-none");
            else $(element).addClass("d-none");
        });
    }

    function moveContent(sourceSelector, targetSelector, hideSelector, showSelector) {
        $(".dynamic-mobile-accordion div[class*=mobile-accordion-item-]").each(function (i, element) {
            var x = $(element).data("itemNumber");
            var source = sourceSelector.replace("X", x);
            var target = targetSelector.replace("X", x);

            // since target is unique, the appendTo will moves elements and preserve event handlers on them
            $(source).children().appendTo(target);

            if (hideSelector) {
                var hide = hideSelector.replace("X", x);
                $(hide).addClass("d-none");
            }
            if (showSelector) {
                var show = showSelector.replace("X", x);
                $(show).removeClass("d-none");
            }
        });
    }

    initEventHandlers();
    windowResized();
});

define("DynamicMobileAccordion/main", function(){});

